import { useStore } from "../../hooks";
import Header from "./Header";

const Layout = ({ children }) => {
  const isHomePath = window.location.pathname === "/";
  const { auth } = useStore();
  const basaksehirRole = auth?.user?.roles?.some((role) =>
    role.includes("observer")
  );
  return (
    <div className="flex flex-col h-screen">
      <Header basaksehirRole={basaksehirRole} />
      <main
        className={`flex flex-1 flex-col max-w-full ${
          !basaksehirRole ? "py-8 lg:pl-72" : "py-4"
        }          overflow-x-hidden overflow-y-scroll h-[100dvh] max-h-full`}
      >
        <div className="px-4 sm:px-6 lg:px-8">{children}</div>
      </main>
    </div>
  );
};

export default Layout;
